import { render, staticRenderFns } from "./BatchUploadTable.vue?vue&type=template&id=04ae32fa&scoped=true"
import script from "./BatchUploadTable.vue?vue&type=script&lang=js"
export * from "./BatchUploadTable.vue?vue&type=script&lang=js"
import style0 from "./BatchUploadTable.vue?vue&type=style&index=0&id=04ae32fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ae32fa",
  null
  
)

export default component.exports